import React, { useState } from "react";
import classes from './emergencyContact.module.scss';
import cx from 'classnames';
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from "react-redux";
import { CommentSvg, EmailSvg, PhoneSvg } from "../../constants/resources";
import CachedLink from "../CachedLink";

const EmergencyContact = (props: any) => {
    const { buliddata } = props;
    const [showMore, setShowMore] = useState(false);
    const [activeNode, setActiveNode] = useState(false);
    const ShareType = useSelector((state: any) => state.Question.ShareType);
    const [size, setSize] = useState(3);
    let i = 0;
    const ShowMoreless = () => {
        if (!showMore) {
            setSize(buliddata?.emergencyContacts?.length)
            setShowMore(!showMore)
        }
        else
            setSize(3)
        setShowMore(!showMore)
    }



    return (
        <>
            {buliddata?.emergencyContacts?.length > 0 && ShareType !== "friends" ?
                <div className={classes.box}>
                    {activeNode &&
                        <div className={classes.shadow} onClick={() => setActiveNode(false)}>
                        </div>}
                    <div className={cx(classes.emergancy, classes.emergancyMobile, activeNode ? classes.mobileListView : classes.mobileListHide)} >
                        <div className={classes.close}>
                            <HorizontalRuleOutlinedIcon onClick={() => setActiveNode(!activeNode)} />
                        </div>
                        <div className={classes.emergancyinfo}>
                            <span className={classes.close}>
                                <CloseIcon onClick={() => setActiveNode(!activeNode)} />
                            </span>
                            Emergency Contact Info
                        </div>
                        <div className={classes.flex}>
                            {buliddata?.emergencyContacts?.slice(0, size).map((node: any, index: number) => {
                                i = i + 1
                                return (
                                    <div key={index} style={{ width: "auto", marginBottom: "10px" }}>
                                        <div className={classes.contactinfo}>Contact #{i}</div>
                                        <div className={classes.info}>
                                            <div className={classes.phone}>
                                                <CachedLink href={"tel://" + node.phone}>
                                                    <PhoneSvg />
                                                    {node.phone}
                                                </CachedLink>
                                            </div>
                                            <div className={classes.email}>
                                                <CachedLink target="_blank" href={"mailto:" + node.email} rel="noreferrer">
                                                    <EmailSvg /> {node.email} </CachedLink></div>

                                            {node?.comment ?
                                                <div className={classes.comments}>
                                                    <CommentSvg />
                                                    <p>{node.comment}</p> </div> : null}
                                        </div>

                                    </div>
                                )
                            })
                            }
                        </div>
                        <div className={classes.showbutton}>
                            {showMore && buliddata?.emergencyContacts?.length > 3 && <div className={classes.showhide} onClick={() => ShowMoreless()}>Hide</div>}
                            {!showMore && buliddata?.emergencyContacts?.length > 3 && <div className={classes.showhide} onClick={() => ShowMoreless()}> Show All</div>}
                        </div >

                    </div>
                    <div className={classes.EmergencyContact}>
                        {!activeNode &&
                            <div className={classes.EmergencyContactButton} onClick={() => setActiveNode(!activeNode)} >
                                Emergency Contact Info
                            </div>}
                    </div>
                </div>
                : null}
        </>
    )
}

export default EmergencyContact